export function formattedAddress({
  houseNumber,
  municipality,
  street,
  zipCode,
  postalCode,
  bus,
  busLabel,
  country,
}: {
  street?: string | null | undefined;
  houseNumber?: string | null | undefined;
  bus?: string | null | undefined;
  busLabel?: string | null | undefined;
  zipCode?: string | null | undefined;
  postalCode?: string | null | undefined;
  municipality?: string | null | undefined;
  country?: string | null | undefined;
}): string {
  const parts: string[] = [];
  if (street || houseNumber) parts.push(`${street ?? ''} ${houseNumber ?? ''}`);
  if (bus) parts.push(`${busLabel ?? ''} ${bus}`);
  if (zipCode || municipality) parts.push(`${zipCode ?? postalCode ?? ''} ${municipality ?? ''}`);
  if (country) parts.push(country);

  return parts.join(', ');
}
